import { useQueryClient } from '@tanstack/react-query';
import { useLocation, useNavigate } from 'react-router-dom';
import {
  appendSellerSupportMessageToCache,
  SELLER_CHAT_UNREAD_QUERY_KEY,
} from '../chat-cache';
import { useSellerSupportChatSocket } from '../hooks/useSellerSupportChatSocket';
import { showSupportChatIncomingToast } from '../support-chat-toast';

type SellerSupportChatToastListenerProps = {
  enabled?: boolean;
};

/** Тост при новом сообщении от админа, если пользователь не на странице чата. */
export function SellerSupportChatToastListener({
  enabled = true,
}: SellerSupportChatToastListenerProps) {
  const queryClient = useQueryClient();
  const location = useLocation();
  const navigate = useNavigate();
  const onChatPage = location.pathname.startsWith('/support-chat');

  useSellerSupportChatSocket(
    {
      onMessage: ({ message }) => {
        if (message.senderKind !== 'SUPER_ADMIN') return;
        appendSellerSupportMessageToCache(queryClient, message);
        if (onChatPage) return;
        showSupportChatIncomingToast({
          title: message.senderName?.trim() || 'Поддержка',
          body: message.body,
          imageCount: message.imageUrls?.length ?? 0,
          messageId: message.id,
          onOpen: () => navigate('/support-chat'),
        });
      },
      onUnread: ({ scope, count }) => {
        if (scope !== 'seller' || onChatPage) return;
        queryClient.setQueryData(SELLER_CHAT_UNREAD_QUERY_KEY, { count });
      },
    },
    enabled && !onChatPage,
  );

  return null;
}
